import { z } from 'zod';
import { password } from './password';

export const schema = z
	.object({
		nickname: z.string().min(1, {
			message: 'Name is required'
		}),
		email: z
			.string({
				required_error: 'Email is required'
			})
			.email({
				message: 'Email must be valid email'
			}),
		password,
		confirmPassword: z.string()
	})
	.refine((data) => data.password === data.confirmPassword, {
		message: 'Passwords do not match',
		path: ['confirmPassword']
	});
